import { render, staticRenderFns } from "./NotificationTimeLimitChange.vue?vue&type=template&id=cff1bd16"
import script from "./NotificationTimeLimitChange.vue?vue&type=script&lang=js"
export * from "./NotificationTimeLimitChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports